/* ••[1]••••••••••••••••••••••••• VanillaApi.ts •••••••••••••••••••••••••••••• */

import { PaginationLink } from "./Pagination";

interface VanillaApiTag {
  tagID: number;
  id: number;
  name: string;
  urlCode: string;
}

interface VanillaApiRole {
  roleID: number;
  name: string;
}

interface VanillaApiUser {
  banned: number;
  bypassSpam: false;
  email: string;
  emailConfirmed: true;
  dateInserted: string;
  dateLastActive: string;
  dateUpdated: string;
  name: string;
  photoUrl: string;
  url: string;
  points: number;
  roles: Array<VanillaApiRole>;
  showEmail: boolean;
  userID: number;
  countDiscussions: number;
  countComments: number;
  countPosts: number;
  permissions?: Array<string>;
}

interface VanillaApiCurrentUser {
  userID: number;
  name: string;
  photoUrl: string;
  email: string;
  permissions: Array<string>;
}

interface VanillaApiQuestion {
  status: string;
  dateAccepted: string | null;
  dateAnswered: string | null;
  acceptedAnswers: [];
}

interface VanillaApiIdea {
  statusNotes: string | null;
  statusID: number;
  status: {
    name: string;
    state: string;
  };
  type: string;
}

interface VanillaApiBadge {
  badgeID: number;
  name: string;
  photoUrl: string;
  url: string;
}

interface VanillaCategory {
  categoryID: number;
  name: string;
  description: string;
  parentCategoryID: number | null;
  customPermissions: boolean;
  isArchived: boolean;
  urlcode: string;
  url: string;
  displayAs: string;
  iconUrl: string | null;
  dateInserted: string;
  bannerUrl: string;
  countCategories: number;
  countDiscussions: number;
  countComments: number;
  countAllDiscussions: number;
  countAllComments: number;
  followed: boolean;
  // breadcrumbs: Array<any>,
  featured: boolean;
  allowedDiscussionTypes: Array<string>;
  depth: number;
  // TODO: Fix any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: Array<any>;
  fields: Array<string>;
}

interface VanillaDiscussion {
  discussionID: number;
  type: string;
  name: string;
  body: string;
  categoryID: number;
  dateInserted: string;
  dateUpdated: string | null;
  dateLastComment: string; //"2021-05-10T20:54:54+00:00",
  insertUserID: number;
  insertUser: {
    userID: number;
    name: string;
    url: string;
    photoUrl: string;
    dateLastActive: string;
  };
  updateUserID: number | null;
  lastUserID: number;
  lastUser: {
    userID: number;
    name: string;
    url: string;
    photoUrl: string;
    dateLastActive: string;
  };
  pinned: boolean;
  pinLocation: string | null;
  closed: boolean;
  sink: boolean;
  countComments: number;
  countViews: number;
  score: number | null;
  hot: number;
  url: string;
  canonicalUrl: string;
  format: string;
  groupID: number | null;
  bookmarked: boolean;
  unread: boolean;
  attributes: {
    question?: VanillaApiQuestion;
    idea?: VanillaApiIdea;
  };
}

interface VanillaEvent {
  eventID: number;
  parentRecordType: string;
  parentRecordID: number;
  name: string;
  body: string;
  excerpt: string;
  location: string;
  locationUrl: string;
  safeLocationUrl: string;
  attending: string;
  dateStarts: string;
  dateStart: Date;
  dateEnds: string;
  dateEnd: Date;
  allDayEvent: boolean;
  dateInserted: string;
  datePosted: Date;
  insertUserID: number;
  insertUser: VanillaApiUser;
  dateUpdated: string;
  updateUserID: number;
  url: string;
  ctaUrl?: string;
}

interface VanillaPoll {
  pollID: number;
  name: string;
  discussionID: number;
  categoryID: number;
  countOptions: number;
  countVotes: string;
  insertUserID: string;
  dateInserted: string;
  updateUserID: string;
  dateUpdated: string;
  pollOption: VanillaPollOption[];
}

interface VanillaPollOption {
  pollOptionID: number;
  pollID: number;
  body: string;
  format: string;
  sort: number;
  countVotes: number;
  dateInserted: string;
  insertUserID: string;
  dateUpdated: string;
  updateUserID: string;
}

enum VanillaRSVP {
  Going = "yes",
  NotGoing = "no",
  Maybe = "maybe",
}

interface VanillaDiscussionsPage {
  data: Array<VanillaDiscussion>;
  pagination: Map<string, PaginationLink>;
}

export {
  VanillaApiTag,
  VanillaApiRole,
  VanillaApiUser,
  VanillaApiCurrentUser,
  VanillaApiBadge,
  VanillaCategory,
  VanillaDiscussion,
  VanillaEvent,
  VanillaRSVP,
  VanillaDiscussionsPage,
  VanillaPoll,
};
